import { useCallback, useEffect } from 'react';

import { useWorkspaceSidebarPushStore } from '~/components/v2/store/features/workspace/useWorkspaceSidebarPushStore';

export const useWorkspaceSidebarPushLock = ({ token }: { token: string }) => {
  const lockPush = useWorkspaceSidebarPushStore((s) => s.lockPush);
  const unlockPush = useWorkspaceSidebarPushStore((s) => s.unlockPush);

  useEffect(() => () => unlockPush(token), [token, unlockPush]);

  const handleOpenChange = useCallback(
    (open: boolean) => {
      if (open) {
        lockPush(token);
      } else {
        unlockPush(token);
      }
    },
    [token, lockPush, unlockPush],
  );

  return { handleOpenChange };
};
